import { useInfiniteQuery } from '@tanstack/react-query';
import { trackError } from 'Utils/errorMonitoring';
import { RESULTS_PER_PAGE } from 'Utils/constants';
import { getReferences } from 'Services/references';

export default function useInfiniteReferences(filters = {}) {
    return useInfiniteQuery(
        ['references', filters],
        async ({ pageParam = 1 }) => {
            return getReferences({
                ...filters,
                page: pageParam,
            });
        },
        {
            refetchOnWindowFocus: false,
            onError: (err) => trackError(err),
            getNextPageParam: (lastPage, allPages) => {
                const pagesLoaded = allPages.length;
                const totalPages = Math.ceil(lastPage.count / RESULTS_PER_PAGE);
                return pagesLoaded < totalPages ? pagesLoaded + 1 : false;
            },
        },
    );
}
